export const defaultLangConstants = {
    landingHeroTitle: 'Your Favorites, Delivered.',
    landingHeroSubtitle: 'All Day, All Night. In about 30 Minutes.*',
    LANDING_SLOGAN: 'Get your favorite items delivered to your door.',
    LANDING_BENEFIT1_TITLE: 'Delivery Anytime',
    LANDING_BENEFIT1_SUBTITLE: '24/7 Service',
    LANDING_BENEFIT2_SUBTITLE: 'Discover our large product selection.',
    LANDING_BENEFIT3_TITLE: 'In about 30 Minutes*',
    LANDING_BENEFIT3_SUBTITLE: 'Fast and contactless delivery.',
    LANDING_BENEFIT4_TITLE: 'Exclusive Deals',
    LANDING_BENEFIT4_SUBTITLE: 'Plus free delivery on your first order.**',
    LOADING_BENEFIT_MUCH_MORE: 'And so much more!',
    LOADING_SHOP_NOW_BUTTON: 'Shop Now',
    inputAddress: 'Input your address to get started.',
    LANDING_LOCATION_USE_CURRENT: 'Use current location',
    ADDRESS_PICKUP_PLACEHOLDER: 'City, State or Address',
    addressBarPlaceholder: 'Enter Delivery Address',
    invalidAddress: 'Sorry, we couldn’t recognize that address.',
    LANDING_BENEFIT2_TITLE: '500+ Products',
    LOADING_FAQ_TITLE: 'Frequently Asked Questions',
}
